// Clients
import {
  Location, LocationDetail
} from '../../../clients/BackendAdminClient/project-address'

// Utils
import {
  ValidateUtility as Validate
} from '../utils/validate'

/**
 * @typedef Option
 * @type {Object}
 * @property {String} name  : Type name
 * @property {String} value : Type value
 */

export class NonScCommon {

  /** @type {Array<Option>} */
  static category = [
    {
      name  : 'แนวราบ',
      value : 'NSL'
    },
    {
      name  : 'แนวสูง',
      value : 'NSH'
    },
  ]

  /** @type {Location} */
  static location = {
    zipCode       : null,
    tumbonCode    : null,
    tumbonPrefix  : null,
    tumbonName    : null,
    amphurPrefix  : null,
    amphurCode    : null,
    amphurName    : null,
    provinceName  : null,
    provinceCode  : null
  }

  /** @type {Array<Option>} */
  static role = [
    {
      name  : 'ผู้ถือกรรมสิทธิ์',
      value : 'OWNER'
    },
    {
      name  : 'ผู้อยู่อาศัย',
      value : 'RESIDENT'
    },
    {
      name  : 'ผู้เช่า',
      value : 'RENTER'
    },
  ]

  /** @type {Array<Option>} */
  static construct = [
    {
      name  : 'บ้านเดี่ยว',
      value : 'HO'
    },
    {
      name  : 'บ้านแฝด',
      value : 'HO'
    },
    {
      name  : 'คอนโดมิเนียม',
      value : 'CO'
    },
    {
      name  : 'ทาวน์เฮ้าส์',
      value : 'TH'
    },
  ]

  /**
   * Format to mobile number
   * @param {String} input - Input text
   * @returns {String} Mobile Number
   */
  static toMobileNo(input) {

    // Validate input
    if (typeof input != 'string') return null

    // Replace Prefix
    return input.replace('66', '0')
  }

  static setRole(input) {
    return this.role.find(
      e => e.name == input || e.value == input
    )
  }
  
  /**
   * Set location
   * @param {*} input - Input
   * @returns {LocationDetail} location props
   */
  static setLocation(input) {

    // Validate Input
    if (!input) return null
    
    // Location Validator
    const isLocation = (
      Validate.isLocation(input)
    )

    // Validate Address
    if (!isLocation) return null

    // Address Props
    const address = [
      'tumbonPrefix',
      'tumbonName',
      'amphurPrefix',
      'amphurName',
      'provinceName' ,
      'zipCode',
    ]

    return address.reduce(
      (e, key) => ({ ...e, [key]: input[key] }), {}
    )
  }

  /**
   * Error message mapper
   * @param {*} error - Error code
   * @returns {String} Error message 
   */
  static error(error = 'TRY_AGAIN') {

    // Error messages
    const messages = {
      
      // Project
      NONSC_PROJECT_ADDRESS_INVALID     : 'ที่อยู่โครงการไม่ถูกต้อง',
      NONSC_PROJECT_CODE_INVALID        : 'รหัสโครงการไม่ถูกต้อง',
      NONSC_PROJECT_CODE_CONFLICT       : 'รหัสโครงการซ้ำ',
      NONSC_PROJECT_ID_INVALID          : 'เลขรหัสโครงการไม่ถูกต้อง',
      NONSC_PROJECT_IMAGE_TYPE_INVALID  : 'ประเภทรูปโครงการไม่ถูกต้อง',
      NONSC_PROJECT_IMAGE_URL_INVALID   : 'ลิงก์รูปโครงการไม่ถูกต้อง',
      NONSC_PROJECT_NAME_INVALID        : 'ชื่อโครงการไม่ถูกต้อง',
      NONSC_PROJECT_NOT_FOUND           : 'ไม่พบโครงการ',
      NONSC_PROJECT_PIN_INVALID         : 'พิกัดโครงการไม่ถูกต้อง',
      NONSC_PROJECT_TYPE_INVALID        : 'ประเภทโครงการไม่ถูกต้อง',

      // Home
      NONSC_HOME_ADDRESS_INVALID        : 'ที่อยู่บ้านไม่ถูกต้อง',
      NONSC_HOME_AREA_INVALID           : 'พื้นที่ใช้สอยไม่ถูกต้อง',
      NONSC_HOME_DUPLICATE              : 'ข้อมูลบ้านซ้ำ',
      NONSC_HOME_EXISTS                 : 'ข้อมูลบ้านมีอยู่แล้ว',
      NONSC_HOME_PROJECT_INVALID        : 'ข้อมูลโครงการไม่ถูกต้อง',
      NONSC_HOME_TRANSFER_DATE_INVALID  : 'วันที่โอนไม่ถูกต้อง',
      NONSC_HOME_TYPE_INVALID           : 'ประเภทบ้านไม่ถูกต้อง',
      
      // User
      NONSC_USER_EMAIL_INVALID          : 'อีเมล์ลูกบ้านไม่ถูกต้อง',
      NONSC_USER_EMAIL_CONFLICT         : 'อีเมล์ลูกบ้านซ้ำ',
      NONSC_USER_EMAIL_EXISTS           : 'อีเมล์ลูกบ้านมีอยู่แล้ว',
      NONSC_USER_HOME_INVALID           : 'ข้อมูลบ้านไม่ถูกต้อง',
      NONSC_USER_MOBILE_NUMBER_INVALID  : 'เบอร์มือถือลูกบ้านไม่ถูกต้อง',
      NONSC_USER_MOBILE_NUMBER_CONFLICT : 'เบอร์มือถือลูกบ้านซ้ำ',
      NONSC_USER_MOBILE_NUMBER_EXISTS   : 'เบอร์มือถือลูกบ้านมีอยู่แล้ว',
      NONSC_USER_PROJECT_INVALID        : 'ข้อมูลโครงการไม่ถูกต้อง',
      NONSC_USER_ROLE_INVALID           : 'ข้อมูลสถานะไม่ถูกต้อง',
      NONSC_USER_INVALID                : 'ข้อมูลลูกบ้านไม่ถูกต้อง',
      TRY_AGAIN                         : 'มีบางอย่างผิดพลาด โปรดลองอีกครั้ง',
    }

    // Instance Validator
    const isInstance = (
      error && error.message
    )

    // Validate Instance
    if (isInstance) {
      error = error.message || 'TRY_AGAIN'
    }

    // Error Code Validator
    const isError = (
      Object.keys(messages).includes(error)
    )

    return (
      isError ? messages[error] : messages['TRY_AGAIN']
    )
  }
}




// WEBPACK FOOTER //
// ./src/features/nonsc/common/nonsc.common.js